import { useHandoverQueueTableColumns } from './';

export const useHandoverQueueTable = () => {
  const columns = useHandoverQueueTableColumns();

  return { columns };
};
